import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import { Fragment, useCallback, useMemo, useState } from 'react';
import { PanelItemDivider } from '../../../panels/panelItemDivider';
import { NewsItemDisplay } from './newsItemDisplay';
import { getNewsItemHash, getNewsItems } from './newsItems';
function getNumNewsItemsToHighlight(newsItems, lastNewsItemHash) {
    if (!lastNewsItemHash) {
        return 0;
    }
    const matchingNewsItemIndex = newsItems.findIndex((newsItem) => getNewsItemHash(newsItem) === lastNewsItemHash);
    if (matchingNewsItemIndex === -1) {
        return 0;
    }
    // there is a news item matching the stored hash, so return the number of total news items that are more recent:
    return newsItems.length - matchingNewsItemIndex - 1;
}
export const NewsContents = ({ numItemsPerPage, lastNewsItemHash }) => {
    const [numItemsToShow, setNumItemsToShow] = useState(numItemsPerPage);
    const newsItems = getNewsItems();
    const numNewsItemsToHighlight = useMemo(() => getNumNewsItemsToHighlight(newsItems, lastNewsItemHash), [newsItems, lastNewsItemHash]);
    const onClickShowMore = useCallback(() => {
        setNumItemsToShow((currNumItemsToShow) => currNumItemsToShow + numItemsPerPage);
    }, [numItemsPerPage]);
    const startIndex = Math.max(0, newsItems.length - numItemsToShow);
    const newsItemsToShow = newsItems.slice(startIndex);
    newsItemsToShow.reverse();
    return (_jsxs(_Fragment, { children: [newsItemsToShow.map((newsItem, i) => {
                const isHighlighted = i < numNewsItemsToHighlight;
                return (_jsxs(Fragment, { children: [i > 0 && _jsx(PanelItemDivider, { color: '#555', thicknessPx: 1, marginPx: 0 }), _jsx(NewsItemDisplay, { newsItem: newsItem, isHighlighted: isHighlighted })] }, i));
            }), startIndex > 0 && (_jsx("div", { children: _jsx(Button, { variant: 'outlined', onClick: onClickShowMore, size: 'small', children: "More" }) }))] }));
};
